export { default as PrimaryStatisticalCategories } from './PrimaryStatisticalCategories';
export { default as SecondaryStatisticalCategories } from './SecondaryStatisticalCategories';



// WEBPACK FOOTER //
// ./src/components/line/additionalCategories/index.js